import {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectBecomeCreatorData,
  setIsFetchedStatus,
} from '@/src/app/store/user/becomeCreatorSlice';
import useLoading from '@/src/hooks/useLoading';

import PopupContext from '../../../popup/utils/PopupContext';
import BecomeCreatorPopupLayout from '../components/BecomeCreatorPopupLayout';
import postBecomeCreatorData from '../utils/postBecomeCreatorData';
import putBecomeCreatorData from '../utils/putBecomeCreatorData';

const BecomeCreatorPopup = () => {
  const {isLoading, setLoading} = useLoading();
  const {closePopup} = useContext(PopupContext);
  const becomeCreatorData = useSelector(selectBecomeCreatorData);
  const dispatch = useDispatch();

  const handleSubmitClick = useCallback(
    async (values, {setFieldError}) => {
      const requestMethod = becomeCreatorData.becomeCreatorData
        ? putBecomeCreatorData
        : postBecomeCreatorData;

      setLoading(true);

      const {status, responseBody} = await requestMethod(
        values.medical_identificator_file,
        values.medical_identificator,
        becomeCreatorData.becomeCreatorData
          ? becomeCreatorData.becomeCreatorData.id
          : null
      );

      setLoading(false);

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(setIsFetchedStatus(false));
        closePopup();
      }

      if (
        responseBody &&
        responseBody.error &&
        typeof responseBody.error === 'object'
      ) {
        for (const key in responseBody.error) {
          if (Object.prototype.hasOwnProperty.call(responseBody.error, key)) {
            setFieldError(key, responseBody.error[key]);
          }
        }
      }
    },
    [becomeCreatorData, setLoading]
  );

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, [closePopup]);

  return (
    <BecomeCreatorPopupLayout
      onSubmitClick={handleSubmitClick}
      onCancelClick={handleCancelClick}
      initialDocument={
        becomeCreatorData?.doctorProfile?.medical_identificator_file
      }
      initialDocumentType={
        becomeCreatorData?.doctorProfile
          ?.medical_identificator_file_content_type
      }
      isLoading={isLoading}
    />
  );
};

export default BecomeCreatorPopup;
